import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useState } from 'react';
import { Box } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';
import lodashGet from 'lodash.get';
// Internal dependencies
import { Header } from '../header';
import { SideBar } from '../side-bar';
import { Main } from '../main';
import { MULTILANGUAGE, OUTPUT_LANGUAGES } from '../constants';
;
/**
 * Root
 * @param {RootProps} props
 */
export const Root = function (props) {
    const { i18n } = useTranslation();
    /** Mobile Open flag */
    const [mobileOpen, setMobileOpen] = useState(false);
    /** Detected language name in the Multilanguage list */
    const detectedLanguage = lodashGet(MULTILANGUAGE, [`${i18n.language}`, 'englishName']);
    if (!detectedLanguage) {
        i18n.changeLanguage(MULTILANGUAGE.en.value);
    }
    /** Output language */
    const [outputLanguage, setOutputLanguage] = useState(OUTPUT_LANGUAGES.default);
    /** Handle drawer toggle */
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    // Set drawerWidth for each languages
    let drawerWidth = '5rem';
    switch (i18n.language) {
        case MULTILANGUAGE.ja.value:
        case MULTILANGUAGE.en.value:
            drawerWidth = '5.6rem';
            break;
        case MULTILANGUAGE.th.value:
        case MULTILANGUAGE.vi.value:
            drawerWidth = '6rem';
            break;
        default:
            break;
    }
    ;
    return (_jsxs(Box
    // Root component
    , Object.assign({ 
        // Root component
        sx: { height: '100%', backgroundColor: 'whiteDark.main' } }, { children: [_jsx(Header, { handleDrawerToggle: handleDrawerToggle, setOutputLanguage: setOutputLanguage, outputLanguage: outputLanguage }), _jsx(SideBar, { mobileOpen: mobileOpen, handleDrawerToggle: handleDrawerToggle, drawerWidth: drawerWidth }), _jsx(ToastContainer
            // Notification toaster
            , { 
                // Notification toaster
                position: "top-right", autoClose: 5000, hideProgressBar: false, newestOnTop: false, closeOnClick: true, rtl: false, pauseOnFocusLoss: true, draggable: true, pauseOnHover: true, theme: "light" }), _jsx(Main
            // Main component
            , { 
                // Main component
                outputLanguage: outputLanguage, drawerWidth: drawerWidth })] })));
};
